export interface Experiment {
  id: string;
  title: string;
  category: string;
  status: "进行中" | "已完成" | "待开始" | "已暂停";
  coverImage: string;
  createdAt: string;
}

export const experimentCategories = [
  "催化材料",
  "生物材料",
  "新能源",
  "催化化学",
  "医学处理",
  "神经科学",
  "公共安全",
  "材料科学",
  "信号处理",
  "生物工程",
  "量子物理",
  "基因组学",
];

export const experimentStatusList: Experiment["status"][] = [
  "进行中",
  "已完成",
  "待开始",
  "已暂停",
];

export const experimentsData: Experiment[] = [
  {
    id: "1",
    title: "HEA催化剂设计",
    category: "催化材料",
    status: "进行中",
    coverImage:
      "https://readdy.ai/api/search-image?query=glowing%20glass%20orb%20laboratory%20catalytic%20materials%20scientific%20experiment%20bright%20light%20clean%20white%20background%20research&width=400&height=240&seq=exp001&orientation=landscape",
    createdAt: "2025-01-02 14:14:25",
  },
  {
    id: "2",
    title: "基于强化学习的二维材料生长参数自适应调控",
    category: "生物材料",
    status: "进行中",
    coverImage:
      "https://readdy.ai/api/search-image?query=humanoid%20robot%20android%20figure%20standing%20elegant%20biomaterial%20science%20white%20background%20studio%20lighting%20futuristic&width=400&height=240&seq=exp002&orientation=landscape",
    createdAt: "2025-01-02 14:14:25",
  },
  {
    id: "3",
    title: "多模态AI辅助的钙钛矿太阳能电池材料缺陷预测",
    category: "新能源",
    status: "已完成",
    coverImage:
      "https://readdy.ai/api/search-image?query=industrial%20robot%20arm%20factory%20automation%20machinery%20metal%20new%20energy%20production%20line%20clean%20light%20background&width=400&height=240&seq=exp003&orientation=landscape",
    createdAt: "2025-01-02 14:14:25",
  },
  {
    id: "4",
    title: "AI驱动的绿色催化剂筛选与活性位点预测",
    category: "催化化学",
    status: "进行中",
    coverImage:
      "https://readdy.ai/api/search-image?query=industrial%20chemical%20laboratory%20dark%20moody%20catalytic%20chemistry%20equipment%20pipes%20reactor%20atmospheric%20scientific&width=400&height=240&seq=exp004&orientation=landscape",
    createdAt: "2025-01-02 14:14:25",
  },
  {
    id: "5",
    title: "基于联邦学习的个性化肿瘤免疫治疗方案推荐",
    category: "医学处理",
    status: "待开始",
    coverImage:
      "https://readdy.ai/api/search-image?query=small%20robots%20building%20blocks%20construction%20medical%20research%20team%20collaboration%20minimal%20clean%20background%20technology&width=400&height=240&seq=exp005&orientation=landscape",
    createdAt: "2025-01-02 14:14:25",
  },
  {
    id: "6",
    title: "AI驱动的神经退行性疾病预警与干预",
    category: "神经科学",
    status: "进行中",
    coverImage:
      "https://readdy.ai/api/search-image?query=glowing%20neural%20sphere%20orb%20electric%20neural%20network%20connections%20dark%20background%20brain%20activity%20neuroscience&width=400&height=240&seq=exp006&orientation=landscape",
    createdAt: "2025-01-02 14:14:25",
  },
  {
    id: "7",
    title: "AI驱动的青少年抑郁风险预测与早期干预",
    category: "公共安全",
    status: "已完成",
    coverImage:
      "https://readdy.ai/api/search-image?query=futuristic%20AI%20text%20display%20neon%20blue%20letters%20dark%20background%20public%20safety%20technology%20surveillance%20system&width=400&height=240&seq=exp007&orientation=landscape",
    createdAt: "2025-01-02 14:14:25",
  },
  {
    id: "8",
    title: "强化学习辅助的可控核裂变装置参数优化",
    category: "材料科学",
    status: "进行中",
    coverImage:
      "https://readdy.ai/api/search-image?query=mechanical%20engineering%20workshop%20lathe%20machine%20tools%20precision%20materials%20science%20manufacturing%20industrial%20minimal&width=400&height=240&seq=exp008&orientation=landscape",
    createdAt: "2025-01-02 14:14:25",
  },
  {
    id: "9",
    title: "深度学习辅助的引力波信号快速识别与参数估计",
    category: "信号处理",
    status: "已暂停",
    coverImage:
      "https://readdy.ai/api/search-image?query=hands%20working%20with%20electronic%20components%20circuit%20board%20signal%20processing%20lab%20dark%20background%20warm%20light&width=400&height=240&seq=exp009&orientation=landscape",
    createdAt: "2025-01-02 14:14:25",
  },
  {
    id: "10",
    title: "AI辅助的生物启发材料设计与仿生制造",
    category: "生物工程",
    status: "进行中",
    coverImage:
      "https://readdy.ai/api/search-image?query=scientist%20researcher%20working%20in%20laboratory%20bioengineering%20white%20coat%20microscope%20clean%20bright%20lab%20environment&width=400&height=240&seq=exp010&orientation=landscape",
    createdAt: "2025-01-02 14:14:25",
  },
  {
    id: "11",
    title: "量子纠缠辅助的分子模拟与药物靶点发现",
    category: "量子物理",
    status: "待开始",
    coverImage:
      "https://readdy.ai/api/search-image?query=quantum%20physics%20abstract%20visualization%20glowing%20particles%20wave%20interference%20pattern%20dark%20blue%20background%20science&width=400&height=240&seq=exp011&orientation=landscape",
    createdAt: "2025-01-02 14:14:25",
  },
  {
    id: "12",
    title: "单细胞多组学整合分析癌症异质性机制",
    category: "基因组学",
    status: "进行中",
    coverImage:
      "https://readdy.ai/api/search-image?query=DNA%20helix%20genomics%20sequencing%20glowing%20colorful%20strands%20white%20clean%20background%20genetics%20biology%20research&width=400&height=240&seq=exp012&orientation=landscape",
    createdAt: "2025-01-02 14:14:25",
  },
];
